// import dummyOfferTest from './dummy-offer-test';
// import dummyTourTest from './dummy-tour-test';
import pilates28DayChallengeCheckoutApplePayButton from './pilates-28-day-challenge-checkout-apple-pay-button';
import pilates28DayChallengeCheckoutRenewalPricing from './pilates-28-day-challenge-checkout-renewal-pricing';
import pilates28DayChallengeCheckoutSmallPlanSelectors from './pilates-28-day-challenge-checkout-small-plan-selectors';
import pilates28DayChallengeNewEmailConsentStep from './pilates-28-day-challenge-new-email-consent-step';
import pilates28DayChallengeUpdateBmiStep from './pilates-28-day-challenge-update-bmi-step';
import pilatesChallengeAndNutritionYogaPriceIncreaseAu from './pilates-challenge-and-nutrition-yoga-price-increase-au';
import pilates28DayChallengeMultiplePlanSelector from './pilates-challenge-multiple-plan-selector';
import somaticYogaRevampedFunnel from './somatic-yoga-revamped-funnel';
import yoga28DayChallengeRevamp from './yoga-28-day-challenge-revamp';
import yoga28DayChallengeRevampV2 from './yoga-28-day-challenge-revamp-v2';

const tests = [
  // Dummy experiments
  // dummyOfferTest,
  // dummyTourTest,

  pilatesChallengeAndNutritionYogaPriceIncreaseAu,
  pilates28DayChallengeMultiplePlanSelector,
  yoga28DayChallengeRevamp,
  yoga28DayChallengeRevampV2,
  pilates28DayChallengeUpdateBmiStep,
  pilates28DayChallengeCheckoutRenewalPricing,
  pilates28DayChallengeCheckoutApplePayButton,
  pilates28DayChallengeCheckoutSmallPlanSelectors,
  somaticYogaRevampedFunnel,
  pilates28DayChallengeNewEmailConsentStep,
];

export default tests;
